import { defineComponent } from 'vue';
import { Registration } from './Registration.class';
import DirectSigninButton from '../SocialIncentiveButtons/DirectSigninButton/DirectSigninButton.vue';
import Divider from '../Divider/Divider.vue';
import PrivacyStatement from '../privacystatement/PrivacyStatement.vue';
import { inject } from 'vue';
import { IIncentiveV2Store } from '@/domain/dto/store.incentive-v2.interfaces.js';
import { setupComponent } from '@studyportals/vue-platform';
import SocialIncentiveButtons from '../SocialIncentiveButtons/SocialIncentiveButtons.vue';
import RedirectToLogin  from '../Common/RedirectToLogin/RedirectToLogin.vue';


export default defineComponent({
	components: {
		SocialIncentiveButtons,
		DirectSigninButton,
		Divider,
		PrivacyStatement,
		RedirectToLogin
	},
	setup: () => {
		const store = inject<IIncentiveV2Store>('incentiveV2Store');
		if (!store) {
			throw new Error('IncentiveV2Store not provided');
		}
		const component = new Registration(store);
		return setupComponent(component);
	}
});
